module.exports = __webpack_public_path__ + "static/media/logo_updated_blue.bbd8d076.svg";